module.exports = __webpack_public_path__ + "media/images/pc/top/keyword_chapel@2x-7127604f2282f15a25f87f2a0598caaf.webp";